<template>
  <li class="group-item">
    <p
      class="group-name"
      @click="toggle"
      :style="`padding-left: ${depth}em;`"
      :class="{'group-selected' : open }"
    >
      <!-- 折叠图标 -->
      <span
        class="icon"
        :class="[open ? 'fold' : 'collapse']"
      />
      <!-- 部门名 -->
      <span>{{ group['Department.DisplayName'] | toChinese }}</span>
    </p>
    <!-- 部门成员 -->
    <Member
      v-show="open"
      :key="member.Employee.Oid"
      v-for="member in group.employees"
      :member="member.Employee"
      :depth="depth"
    />
    <!-- 子部门 -->
    <ul
      class="group"
      v-show="open"
      v-if="isFolder"
    >
      <GroupItem
        :key="g['Department.DisplayName']"
        v-for="g in group.Children"
        :group="g"
        :depth="depth+1"
      />
    </ul>
  </li>
</template>

<script>
import Member from './Member.vue';

export default {
  name: 'GroupItem',
  props: {
    // 组对象,就是Children列表中的一个对象
    group: {
      type: Object,
      default: () => {
      },
    },
    // 组织架构深度是为了计算出“部门名和成员名向左边偏移的距离,例如深度为1,padding-left: 1em;
    depth: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      open: false,
    };
  },
  filters: {
    toEnglish: name => name.split('|')[1].trim(),
    toChinese: name => name.split('|')[0].trim(),
  },
  methods: {
    toggle() {
      this.open = !this.open;
    },
  },
  computed: {
    isFolder() {
      return this.group.Children && this.group.Children.length;
    },
  },
  components: { Member },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

$line-height: 36px;

.group-item {
  text-align: left;
  font-size: 14px;
  color: $blue;
  list-style: none;
  .group-name {
    line-height: $line-height;
    height: $line-height;
    cursor: pointer;
    &:hover {
      background: $hover-color;
      border-radius: 1px;
    }
    .icon {
      margin-right: 3px;
      display: inline-block;
      background-size: 10px 10px;
      width: 10px;
      height: 10px;
    }
    .collapse {
      background-image: url("../../assets/home/address_book/arrow_collapse@2x.png");
    }
    .fold {
      background-image: url("../../assets/home/address_book/arrow_fold@2x.png");
    }
  }
  // 选中的时候颜色标示
  .group-selected {
    background: $hover-color;
  }
  .group {
    list-style: none;
  }
}
</style>
